import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='stepDelegate' subtitle='BanksComponentSteppable' mdxType="Item">
      <p>
	<code>BanksComponentSteppable</code> is a protocol that processes different output data for specific steps. Whenever{' '}
	<a href={`#${props.component}.submit`}>submit</a> method is called, <code>stepDelegate</code> will trigger the next step in case the call to the mentioned method was successful.
      </p>
      <p>This is provided for the payment method type ADYEN_IDEAL and Objective-C backward compatibility.</p>
      <Item title='didStartLoading' mdxType="Item">
Protocol method notifying of banks loading. 
      </Item>
      <Item title='didReceiveBanks(banks: [IssuingBank])' mdxType="Item">
Protocol method processing issuing banks retrieved.
  <Group summary='Properties' open mdxType="Group">
    <Item title='banks' subtitle='[IssuingBank]' mdxType="Item">
    The issuing banks array associated with this payment flow.
   </Item>
        </Group>
      </Item>
      <pre><code parentName="pre" {...{
          "className": "language-swift"
        }}>{`@objc func didStartLoading()
@objc func didReceiveBanks(_ banks: [IssuingBank])
`}</code></pre>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      